<div class="d-flex py-4 justify-content-between">
  <div class="d-flex gap-2 flex-wrap align-items-center me-3">
    <base-avatar
      [size]="avatarSize.large"
      [image]="offer?.anonymous && !isOfferConfirmed ? '' : offer?.profile?.avatar || ''"
    ></base-avatar>
    <div
      *ngIf="!offer?.anonymous || isOfferConfirmed"
      class="d-flex flex-column justify-content-center mx-2"
    >
      <h3>{{ offer ? offer.profile.firstName + ' ' + offer.profile.lastName : '' }}</h3>
      <div class="d-flex">
        <base-rating
          [currentRate]="isOfferConfirmed ? assignment?.profile?.averageRating : offer?.profile?.averageRating"
          [reviewCount]="isOfferConfirmed ? assignment?.profile?.ratingCount ?? 0 : offer?.profile?.ratingCount ?? 0"
        ></base-rating>
      </div>
    </div>
    <div
      *ngIf="offer && offer.anonymous && !isOfferConfirmed"
      class="d-flex flex-column justify-content-center mx-2"
    >
      <h3 class="m-0">{{ offer.profile.firstName | baseAnonymizeFullName: offer.profile.lastName }}</h3>
      <p
        baseTruncate
        class="m-0 fw-bold text-dark-gray"
      >
        {{ 'inquiry.anonymizedOffer' | translate }}
      </p>
    </div>
    <base-sign-contract-animated-status-button
      class="ms-5 me-2"
      *ngIf="
        validContract?.type === contractSigningType.DIGITAL &&
          (validContract?.signatures?.statusCustomer === signingStatusBySide.in_queue ||
            validContract?.signatures?.statusCustomer === signingStatusBySide.error ||
            validContract?.signatures?.statusPsp === signingStatusBySide.error);
        else standardButton
      "
      [contract]="validContract"
    ></base-sign-contract-animated-status-button>
    <ng-template #standardButton>
      <base-button
        *ngIf="isOfferConfirmed"
        [iconSize]="buttonSizes.md"
        [stateClass]="statusButtonBorder"
        [permissionBased]="true"
        [ngbTooltip]="signStatusTooltip"
        color="dark"
        class="ms-5 me-2"
        icon="fa-solid fa-file-signature pointer"
        (btnClick)="showSignContractsModal($event)"
      ></base-button>
    </ng-template>
    <ng-container
      *ngIf="
        isOfferConfirmed &&
        (!assignment?.assignmentCancelation || (!assignment && !isAssignmentDeRegistered)) &&
        !isEndedAssignment
      "
    >
      <base-button
        (btnClick)="openCandidateDeregisterModal()"
        color="secondary"
        label="externalEmployees.unsubscribe"
      ></base-button>
    </ng-container>
    <base-button
      *ngIf="isOfferConfirmed"
      color="primary"
      class="ms-3"
      [size]="buttonSizes.md"
      [label]="isEndedAssignment ? 'externalEmployees.inquireEmployee' : 'externalEmployees.extendAssignment'"
      (btnClick)="openInquireEmployeeModal()"
    ></base-button>
  </div>
  <i
    class="fa-solid fa-circle-xmark pointer fa-2x"
    (click)="closeModal()"
  ></i>
</div>

<base-horizontal-nav
  class="m-3"
  [tabs]="tabs"
  [current]="currentTab"
  (tabChange)="onTabChange($event)"
></base-horizontal-nav>

<div class="overflow-modal-content">
  <div
    class="modal-tab-content h-100"
    *ngIf="!isOfferConfirmed || (isOfferConfirmed && !isAssignmentsAdmin)"
  >
    <base-customer-offer-master-data-tab
      *ngIf="currentTab.id === customerOfferTabsEnum.MaterData"
      [isInquiryDetailsPage]="true"
      [offer]="offer"
      [inquiryRequirementCategories]="inquiryRequirementCategories"
    ></base-customer-offer-master-data-tab>
    <base-customer-offer-information-tab
      *ngIf="currentTab.id === customerOfferTabsEnum.OfferInformation"
      [offer]="offer"
      [inquiry]="inquiry"
      [locationId]="inquiry.customerLocation?.id"
    ></base-customer-offer-information-tab>
    <base-customer-employee-reviews-tab
      *ngIf="currentTab.id === customerOfferTabsEnum.Reviews"
      [profileId]="offer?.profile?.id || -1"
      [isOfferConfirmed]="isOfferConfirmed"
    ></base-customer-employee-reviews-tab>
    <base-customer-offer-documents-tab
      [offer]="offer"
      *ngIf="currentTab.id === customerOfferTabsEnum.Documents"
    ></base-customer-offer-documents-tab>
    <ng-container *ngIf="showWorkCouncilTab">
      <ng-container *ngIf="offer as currentOffer">
        <base-customer-employee-work-council-tab
          *ngIf="currentTab.id === customerOfferTabsEnum.WorkCouncil"
          [offerId]="currentOffer.id"
          [inquiryId]="inquiry.id"
          [offeredDaysTotalAmount]="(currentOffer.positions || []).length"
          [profileFullName]="currentOffer.profile.firstName + ' ' + currentOffer.profile.lastName"
          [workCouncilStatus]="currentOffer.workCouncilStatus"
        ></base-customer-employee-work-council-tab>
      </ng-container>
    </ng-container>
  </div>

  <div
    class="modal-tab-content h-100"
    *ngIf="isOfferConfirmed && isAssignmentsAdmin"
  >
    <base-customer-employee-master-data-tab
      *ngIf="currentTab.id === customerOfferTabsEnum.MaterData"
      [assignment]="assignment"
    ></base-customer-employee-master-data-tab>
    <base-customer-employee-operation-info-tab
      *ngIf="currentTab.id === customerOfferTabsEnum.AssignmentInformation"
      (signContract)="showSignContractsModal($event)"
      (deregisterEmployee)="openCandidateDeregisterModal()"
      (inquireEmployee)="openInquireEmployeeModal()"
    ></base-customer-employee-operation-info-tab>
    <base-customer-employee-time-recordings-tab
      *ngIf="currentTab.id === customerOfferTabsEnum.TimeRecordings"
      [assignment]="assignment"
    ></base-customer-employee-time-recordings-tab>
    <base-customer-employee-reviews-tab
      *ngIf="currentTab.id === customerOfferTabsEnum.Reviews"
      [assignment]="assignment"
      [isOfferConfirmed]="isOfferConfirmed"
    ></base-customer-employee-reviews-tab>
    <ng-container *ngIf="showWorkCouncilTab && offer">
      <base-customer-employee-work-council-tab
        *ngIf="currentTab.id === customerOfferTabsEnum.WorkCouncil"
        [offerId]="offer.id"
        [inquiryId]="inquiry.id"
        [offeredDaysTotalAmount]="offer.positions.length"
        [profileFullName]="offer.profile.firstName + ' ' + offer.profile.lastName"
        [workCouncilStatus]="offer.workCouncilStatus"
      ></base-customer-employee-work-council-tab>
    </ng-container>
    <base-customer-employee-documents-tab
      *ngIf="currentTab.id === customerOfferTabsEnum.Documents"
      [assignment]="assignment"
    ></base-customer-employee-documents-tab>
  </div>
</div>

<div
  class="modal-footer edge-footer"
  *ngIf="isOfferOpen"
>
  <span></span>
  <div class="d-flex align-items-center gap-2">
    <base-button
      *ngIf="isRejectButtonAvailable"
      class="btn-confirm"
      color="secondary"
      label="candidates.refuse"
      (btnClick)="onAcceptOrRejectOffer(customerOfferActions.reject)"
    >
    </base-button>
    <base-button
      *ngIf="isAcceptButtonAvailable"
      class="btn-confirm"
      color="primary"
      label="candidates.accept"
      (btnClick)="onAcceptOrRejectOffer(customerOfferActions.accept)"
    >
    </base-button>
  </div>
</div>

<ng-template #deregisterCandidateModalBody>
  <base-deregister-candidate-modal
    [form]="deregisterForm"
    [assignment]="assignment"
    [isFormSubmitted]="deregisterFormSubmitted"
  ></base-deregister-candidate-modal>
</ng-template>

<ng-template #addSignSelectionPopup>
  <base-sign-contract-selection
    [modalRef]="addSignModalRef"
    [(signingType)]="signingType"
    [currentAssignment]="assignment"
    (signingTypeChange)="onSignTypeChange($event)"
  ></base-sign-contract-selection>
</ng-template>

<ng-template #addSignPopup>
  <base-sign-contracts-sign
    [modalRef]="digitalSignModalRef"
    [reloadAssignmentAfterSigning]="true"
  ></base-sign-contracts-sign>
</ng-template>

<ng-template #signStatusTooltip>
  <base-sign-contract-status-tooltip
    [contract]="validContract"
    [isPsp]="false"
  ></base-sign-contract-status-tooltip>
</ng-template>

<ng-template #inquireEmployeeModal>
  <base-customer-staff-request-modal
    [isInquireSpecificEmployee]="true"
    [isInquiryDefaultFilter]="true"
    [assignment]="assignment"
    [inquiry]="inquiry"
    [modalRef]="inquireEmployeeModalModalRef"
  ></base-customer-staff-request-modal>
</ng-template>
